export default __webpack_public_path__ + "static/SignUp-14f4fd7b06cef178a30ac111bab23ade.png";